import script from "./HomeTestimonialsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeTestimonialsSection.vue?vue&type=script&setup=true&lang=js"

import "./HomeTestimonialsSection.vue?vue&type=style&index=0&id=1e81bea2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e81bea2"]])

export default __exports__